RivalIQ.module('tours', function (tours, App, Backbone, Marionette, $, _) {

    'use strict';

    tours.secondaryNav = {
        tourId: 'secondaryNav',
        steps: function (options) {
            const navigation = options.navigation;

            const steps = [
                {
                    element: '#overview-subnav-link',
                    content: `<p>Welcome to your ${navigation.name} overview!</p>  Here you can compare your performance to your competition.`,
                    placement: 'bottom'
                },
                {
                    element: '#detailed-metrics-subnav-link',
                    content: 'To compare your metrics to your competitors, including trending over time, check out Detailed Metrics.',
                    placement: 'bottom'
                },
                {
                    element: '.dropdown.x-datepicker',
                    content: 'You can always change the time period you are reviewing using this selector.',
                    placement: 'bottom'
                }
            ];

            // Add top content tour item for social channels
            const hasTopContent = _.find(navigation.items, {
                name: 'Social Posts'
            });

            if (hasTopContent) {

                steps.splice(1, 0, {
                    element: '#social-posts-subnav-link',
                    content: 'Analyze and search every social post, by hashtag, keyword, type, and more. ',
                    placement: 'bottom'
                });
            }

            return steps;
        }
    };

});
